export default __webpack_public_path__ + "static/media/timer_xl3.1c75cdd0.png";